import React, { Component } from 'react';
import { Rect, Group } from 'react-konva';

export class HorizontalTabularDayTimesheetComponentCanvas extends Component {
    render() {
        const { component, isSelected, dimentionsRatio, draggable } = this.props;

        const componentWidthRatio = component.width / 1100.0;
        const componentHeightRatio = component.height / 650.0;

        const smallHeight = 50 * componentHeightRatio * dimentionsRatio;
        const bigHeight = 250 * componentHeightRatio * dimentionsRatio;
        const smallWidth = 100 * componentWidthRatio * dimentionsRatio;
        const bigWidth = 1000 * componentWidthRatio * dimentionsRatio;

        const elementsMarginPosX = 50 * componentWidthRatio * dimentionsRatio;
        const elementsPosX = component.drawPositionX + elementsMarginPosX;
        
        const elementsMarginPosY = 50 * componentHeightRatio * dimentionsRatio;
        const descriptionPosY = component.drawPositionY + elementsMarginPosY;
        let tableElementPosY = component.drawPositionY + 350 * componentHeightRatio * dimentionsRatio;
        
        const componentSecundaryColor = "#EBF5FA";
        const componentWidth = component.width * dimentionsRatio;
        const componentHeight = component.height * dimentionsRatio;
        
        const colElements = [];
        let i;
        for (i = 0; i < 3; i++) {
            let j;
            for (j = 0; j < 7; j++) {
                colElements.push(
                    <Rect key={`${i}-${j}`}
                        x={elementsPosX + smallWidth * j + elementsMarginPosX * j}
                        y={tableElementPosY}
                        width={smallWidth}
                        height={smallHeight}
                        strokeWidth={1}
                        stroke="black"
                        fill={componentSecundaryColor} />
                );

            }

            tableElementPosY += smallHeight + elementsMarginPosY;
        }

        return (
            <Group
                offsetX={component.offsetX}
                offsetY={component.offsetY}
                draggable={draggable}
                onDragEnd={this.props.onDragEnd}
                onClick={this.props.onComponentClick ? () => this.props.onComponentClick(component.internalId) : null} >
                <Rect x={component.drawPositionX}
                    y={component.drawPositionY}
                    width={componentWidth}
                    height={componentHeight}
                    strokeWidth={isSelected ? 3 : 1}
                    stroke={isSelected ? "#6699ff" : "black"}
                    fill={component.color} />

                <Group>
                    <Rect x={elementsPosX}
                        y={descriptionPosY}
                        width={bigWidth}
                        height={bigHeight}
                        strokeWidth={1}
                        stroke="black"
                        fill={componentSecundaryColor} />
                </Group>

                <Group>
                    {colElements}
                </Group>
            </Group>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/bussched/layoutConfigurations/componentCanvas/HorizontalTabularDayTimesheetComponentCanvas.js